import { FlexAnchorProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useHelpLink } from '../../../hooks/navigation'
import { HelpFlexAnchor } from './HelpFlexAnchor'

export interface ContextualHelpLinkProps extends Omit<FlexAnchorProps, 'href'> {
  name?: string
}

export const ContextualHelpLink: FunctionComponent<ContextualHelpLinkProps> = (props) => {
  const helpLink = useHelpLink(props.name)

  return (
    <HelpFlexAnchor
      fontFamily='body'
      fontWeight='normal'
      color='inherit'
      target='_blank'
      display='inline'
      href={helpLink ?? '#'}
      textDecoration='underline'
      {...props}
    />
  )
}
